import { httpClient } from "@services/api/httpClient";

export interface IGetFormBuilderAccessTokenInput {
    forms: ("recruiter" | "offer" | "offer-application" | "forgot-password" | "offer-assesment" | "offer-category")[]
}

export const getFormBuilderAccessToken = async (payload: IGetFormBuilderAccessTokenInput): Promise<string> => {
    const response = await httpClient.post("/auth/form-builder/get-access-token", payload);
    return response.data?.data?.access_token;
}